export const ieInfo = (function () {
	let version = null
	const { userAgent } = navigator

	const msie = userAgent.indexOf('MSIE ')
	const trident = userAgent.indexOf('Trident/')
	const edge = userAgent.indexOf('Edge/')

	if (msie > 0) {
		version = parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10)
	}
	else if (trident > 0) {
		const rv = userAgent.indexOf('rv:')
		version = parseInt(userAgent.substring(rv + 3, userAgent.indexOf('.', rv)), 10)
	}
	else if (edge > 0) {
		version = parseInt(userAgent.substring(edge + 5, userAgent.indexOf('.', edge)), 10)
	}

	if (version) {
		return {
			version
		}
	}
})()